import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isUserComponent} from '@packages/utilities/core-elements';
import {isOverlayTarget} from './target';

/**
 * Returns the rich text children that can be overlay targets: top-level
 * component instances, Popovers, and Modals only. API-nested instances (e.g.
 * in a list item, through the Data API or MCP) render but aren't targets.
 */
export const getRichTextOverlayCandidates = (
  children: readonly ExpressionElement[]
): ExpressionElement[] =>
  children.filter(
    (child) => isUserComponent(child.type) || isOverlayTarget(child)
  );
